var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7857 0H2.20737C0.989509 0 0 0.938616 0 2.09085V26.9092C0 28.0614 0.989509 29 2.20737 29H28.7857C30.0036 29 31 28.0614 31 26.9092V2.09085C31 0.938616 30.0036 0 28.7857 0ZM9.3692 24.8571H4.77455V11.0174H9.37612V24.8571H9.3692ZM7.07187 9.12723C5.59799 9.12723 4.40781 8.00737 4.40781 6.63504C4.40781 5.26272 5.59799 4.14286 7.07187 4.14286C8.53884 4.14286 9.73594 5.26272 9.73594 6.63504C9.73594 8.01384 8.54576 9.12723 7.07187 9.12723V9.12723ZM26.5922 24.8571H21.9975V18.125C21.9975 16.5196 21.9629 14.4547 19.6103 14.4547C17.2161 14.4547 16.8493 16.2025 16.8493 18.0085V24.8571H12.2547V11.0174H16.6625V12.9076H16.7248C17.3406 11.8201 18.8422 10.6743 21.0772 10.6743C25.7272 10.6743 26.5922 13.542 26.5922 17.2705V24.8571V24.8571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.12c4a13d7245d393d8553bd0eb5c1f94.svg";
export { ForwardRef as ReactComponent };